import LocalizedStrings from "react-localization";

export const LocStrings = new LocalizedStrings({
		en: {
				findPharmacyNearYou: "Find a Pharmacy near you:",
				submit: "Submit",
				locateMe: "Locate me",
				or : "or",
				loadingYourResults: "Loading your results…",
				comingSoon: "Coming soon!",
				tel: "Tel",
				hours: "Hours",
				tapAgainForDetails: "Tap again for details",
				miles: "miles",
				yourLocation: "Your location",
				mapView: "Map view",
				listView: "List view",
				locatingPleaseWait: "Locating… Please wait.",
				locationUnavailable: "Location unavailable.",
				accurateLocationDetected: "Accurate location detected.",
				innacurateLocationDetected: "Location detected, but it might not be accurate.",
				locationDetected: "Location detected.",
				thisLocationCouldntBeFound: "This location could not be found.",
				locationIsTooFar: "Your location is too far away from any of our centers.",
		},
		es: {
				findPharmacyNearYou: "Encuentre una farmacia cerca de usted:",
				submit: "Buscar",
				locateMe: "Ubicame",
				or : "o",
				loadingYourResults: "Cargando sus resultados…",
				comingSoon: "Proxima apertura!",
				tel: "Tel",
				hours: "Horas",
				tapAgainForDetails: "Haga clic de nuevo para obtener más detalles",
				miles: "millas",
				yourLocation: "Su ubicación",
				mapView: "Mapa",
				listView: "Lista",
				locatingPleaseWait: "Ubicando… Por favor espere.",
				locationUnavailable: "Ubicación no disponible.",
				accurateLocationDetected: "Se detecto una ubicación precisa.",
				innacurateLocationDetected: "Ubicación detectada, pero puede que no sea precisa.",
				locationDetected: "Ubicación detectada.",
				thisLocationCouldntBeFound: "No se pudo encontrar esta ubicación.",
				locationIsTooFar: "Su ubicación está muy lejos de cualquiera de nuestros centros.",
		}
});
